import {WipLevelDocSchemaV2, type WipLevelDocV2} from "@repo/shared";
import {serverTimestamp} from "firebase/firestore";

import {BaseCollectionConfig} from "../BaseCollectionConfig";
import {collectionNameV2} from "../collectionName";
import {creationHookFactory} from "../factories/creationHookFactory";
import {deletionHookFactory} from "../factories/deletionHookFactory";
import {getByIdHookFactory} from "../factories/getByIdHookFactory";
import {getByIdRealtimeSubFactory} from "../factories/getByIdRealtimeSubFactory";
import {mutationHookFactory} from "../factories/mutationHookFactory";
import {queryHookFactory} from "../factories/queryHookFactory";
import {queryRealtimeHookFactory} from "../factories/queryRealtimeHookFactory";

export class WipLevelCollectionConfigV2 extends BaseCollectionConfig<
  typeof WipLevelDocSchemaV2,
  unknown
> {
  constructor() {
    super(WipLevelDocSchemaV2);
  }

  getCollection(): [string, ...(string | undefined)[]] {
    return [collectionNameV2("wipLevels")];
  }

  parser(id: string, data: any): WipLevelDocV2 {
    return {
      id,
      ...data,
      updatedAt: data?.updatedAt ?? new Date(),
    };
  }

  mapForPersistence(data: WipLevelDocV2): WipLevelDocV2 {
    return {
      ...data,
      updatedAt: serverTimestamp() as any,
    };
  }
}

const config = new WipLevelCollectionConfigV2();
export const useWipLevelV2 = getByIdHookFactory(config);
export const useWipLevelRealtimeSubV2 = getByIdRealtimeSubFactory(config);
export const useWipLevelsV2 = queryHookFactory(config);
export const useRealtimeWipLevelsV2 = queryRealtimeHookFactory(config);
export const useCreateWipLevelV2 = creationHookFactory(config);
export const useUpdateWipLevelV2 = mutationHookFactory(config);
export const useDeleteWipLevelV2 = deletionHookFactory(config);
